export default __webpack_public_path__ + "static/media/pahanini.250b46f8.png";